import moment from 'moment';
import { isToday, toMoment } from '../../utils/dateUtils';
import format from 'string-template';

export const getEndDateFormat = (couponEndDate, i18n) => {
    const endDateMoment = toMoment(couponEndDate);
    const i18nCoupon = i18n.page.INTERSTITIEL.END_DATE;
    if (endDateMoment.isBefore(moment())) {
        return i18nCoupon.EXPIRED;
    } else if (isToday(endDateMoment)) {
        return i18nCoupon.EXPIRES_TODAY;
    } else {
        const days = endDateMoment.toNow(true);
        return format(i18nCoupon.EXPIRES_IN, days);
    }
};



// WEBPACK FOOTER //
// ./src/services/coupon/utils.js